import React from "react";
import { ArrowRight, Phone, CheckCircle2 } from "lucide-react";

const CallToActionSplit = () => {
  return (
    <section className="py-20 px-4 md:px-8 bg-white">
      <div className="max-w-[1600px] mx-auto bg-[#0f172a] rounded-[3rem] overflow-hidden shadow-2xl">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          
          {/* Left Content Side */}
          <div className="p-10 md:p-16 flex flex-col justify-center relative">
            {/* Decorative Red Blur behind text */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-[#ff4a4a] opacity-10 blur-[80px]"></div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight relative z-10">
              Bereit für zuverlässige <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff4a4a] to-red-400">Sanitär- & Heiztechnik?</span>
            </h2>
            
            <p className="text-gray-400 text-lg mb-8 max-w-md relative z-10">
              Egal ob neues Bad, Heizungstausch oder Reparatur – wir kümmern uns darum. Professionell, sauber und fair.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 relative z-10">
              <button 
                onClick={() => {
                  const section = document.getElementById('contact');
                  if (section) {
                    const offset = 100; // height of header
                    const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="px-8 py-4 rounded-full font-bold text-white shadow-lg shadow-red-500/20 hover:shadow-red-500/40 hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-2"
                style={{ backgroundColor: "#ff4a4a" }} 
              >
                Angebot anfordern <ArrowRight className="w-5 h-5" />
              </button>
              
              <a
                href="https://wa.me/41787096702" // Vendos numrin tend ketu
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 rounded-full font-bold text-white border border-gray-700 hover:bg-white/10 transition-all flex items-center justify-center gap-2"
              >
                <Phone size={20} />
                Kontakt aufnehmen
              </a>
            </div>

            {/* Trust Badges */}
            <div className="mt-10 pt-8 border-t border-gray-800 flex items-center gap-6 text-sm font-medium text-gray-500">
              <span className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-[#ff4a4a]" /> Kostenlose Beratung
              </span>
              <span className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-[#ff4a4a]" /> Professionelle Dienstleistungen
              </span>
            </div>
          </div>

          {/* Right Image Side */}
          <div className="relative  min-h-[150px]">
            {/* Foto e re për Sanitär / Banjo Moderne */}
           
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/20 to-transparent lg:bg-gradient-to-l lg:from-transparent lg:via-[#0f172a]/10 lg:to-[#0f172a]"></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CallToActionSplit;